import EditComponent from './FaPiaoSupplierEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';

//组件 
const WebComponents = (props: any) => {

    /** api服务id */
    const apiId = 'faPiaoSupplier';

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'supplierName',
            sorter: true,
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '发票供应商',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent,
        serviceId: 'business'
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponents;
